import { CircularProgress } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import React from "react";
import { useNavigate, useParams } from "react-router";
import styled from "styled-components";
import { useApp } from "../../context";

const Container = styled.div`
  padding: 50px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

export const Resume = observer(function Resume({ children }) {
  const app = useApp();
  const { id, secret } = useParams();
  const navigate = useNavigate();

  const [errState, setErrState] = React.useState(false);

  React.useEffect(() => {
    if (id && secret) {
      setErrState(false);
      app.benchmarks
        .resumeBenchmark(id, secret)
        .then(() => {
          navigate("/benchmark/analytic");
        })
        .catch((e) => {
          setErrState(true);
        });
    }
  }, [id, secret]);

  return (
    <Container>
      <CircularProgress />
    </Container>
  );
});
